<div class="layout__inner-card flex flex-column gap-3 relative">
  @if (wholeLifeInputs$ | async; as wholeLifeInputs) {
    @if (wholeLifeInputs.coverageOptions && wholeLifeInputs.coverageOptions.length) {
      <em-product-selector-card
        title="Assurance permanente"
        i18n-title
        durationTooltip="L'âge maximum pour une durée P65 ou V20 est de 45 ans."
        i18n-durationTooltip
        productType="WHOLE"
        [withToasterAlerts]="withToasterAlerts"
        [coverageAmountOptions]="wholeLifeInputs.coverageOptions"
        [durationOptions]="wholeLifeInputs.durationOptions ?? []"
        [price]="wholeLifeInputs.price"
        [prefilledCoverage]="wholeLifeInputs.prefilledCoverage"
        (inputsAltered)="onProductSelectorInputsAltered($event, 'WHOLE')"></em-product-selector-card>
    }
  }
  @if (termLifeInputs$ | async; as termLifeInputs) {
    @if (termLifeInputs.coverageOptions && termLifeInputs.coverageOptions.length) {
      <em-product-selector-card
        title="Assurance temporaire"
        i18n-title
        durationTooltip="Le client doit avoir 80 ans ou moins à la date de terminaison du contrat."
        i18n-durationTooltip
        productType="TERM"
        [withToasterAlerts]="withToasterAlerts"
        [coverageAmountOptions]="termLifeInputs.coverageOptions"
        [durationOptions]="termLifeInputs.durationOptions ?? []"
        [price]="termLifeInputs.price"
        [prefilledCoverage]="termLifeInputs.prefilledCoverage"
        (inputsAltered)="onProductSelectorInputsAltered($event, 'TERM')"
        (renewalPricesPopupRequested)="onRenewalPricesPopupRequested()"></em-product-selector-card>
    }
  }
  @if (childRiderInputs$ | async; as childRiderInputs) {
    @if (childRiderInputs.coverageOptions && childRiderInputs.coverageOptions.length) {
      <em-product-selector-card
        title="Avenant enfant"
        i18n-title
        titleTooltip="La couverture totale doit être au moins le double de la couverture de l'avenant enfant."
        i18n-titleTooltip
        [withToasterAlerts]="withToasterAlerts"
        [productType]="riderType.CHILD"
        [coverageAmountOptions]="childRiderInputs.coverageOptions"
        [price]="childRiderInputs.price"
        [prefilledCoverage]="childRiderInputs.prefilledCoverage"
        (inputsAltered)="onProductSelectorInputsAltered($event, riderType.CHILD)"></em-product-selector-card>
    }
  }
  @if (disabilityRiderInputs$ | async; as disabilityRiderInputs) {
    @if (
      disabilityRiderInputs.coverageOptions &&
      disabilityRiderInputs.coverageOptions.length &&
      disabilityRiderInputs.durationOptions &&
      disabilityRiderInputs.durationOptions.length
    ) {
      <em-product-selector-card
        title="Avenant invalidité"
        i18n-title
        durationTooltip="Une catégorie 3A ou 4A est requise pour une durée de 5 ans."
        i18n-durationTooltip
        [withToasterAlerts]="withToasterAlerts"
        [productType]="riderType.DISABILITY"
        [coverageAmountOptions]="disabilityRiderInputs.coverageOptions"
        [durationOptions]="disabilityRiderInputs.durationOptions"
        [price]="disabilityRiderInputs.price"
        [prefilledCoverage]="disabilityRiderInputs.prefilledCoverage"
        (inputsAltered)="
          onProductSelectorInputsAltered($event, riderType.DISABILITY)
        "></em-product-selector-card>
    }
  }
  @if (cancerRiderInputs$ | async; as cancerRiderInputs) {
    @if (cancerRiderInputs.coverageOptions && cancerRiderInputs.coverageOptions.length) {
      <em-product-selector-card
        title="Avenant cancer"
        i18n-title
        [withToasterAlerts]="withToasterAlerts"
        [productType]="riderType.CANCER"
        [coverageAmountOptions]="cancerRiderInputs.coverageOptions"
        [price]="cancerRiderInputs.price"
        [prefilledCoverage]="cancerRiderInputs.prefilledCoverage"
        (inputsAltered)="onProductSelectorInputsAltered($event, riderType.CANCER)"></em-product-selector-card>
    }
  }
  @if (policyFee$ | async; as policyFee) {
    <div class="flex flex-row bg-white p-4 border-round min-w-max" style="border: 1px solid var(--surface-d)">
      <h4 class="text-primary text-xl min-w-max mr-5" i18n>Frais de police</h4>
      <p-divider class="w-full"></p-divider>
      <div class="ml-5 text-xl font-medium" i18n
        >{{ policyFee ? (policyFee | emAmount) + '/mois' : 'N/A' }}
      </div>
    </div>
  }
  @if (totalPrice$ | async; as totalPrice) {
    <div
      class="flex flex-row bg-blue-50 p-4 border-round ml-auto items-center justify-content-between"
      style="border: 1px solid var(--surface-d)">
      <h4 class="text-primary text-2xl mb-0 align-content-center" i18n>Total</h4>
      @if (isPriceLoading) {
        <p-progressSpinner styleClass="ml-5 w-2rem h-2rem" strokeWidth="4"></p-progressSpinner>
      } @else {
        <div class="ml-5 text-xl font-semibold" i18n>
          {{ totalPrice ? (totalPrice | emAmount) + '/mois' : 'N/A' }}
        </div>
      }
    </div>
  }
  @if (blocked) {
    <div
      class="border-round absolute top-0 left-0 right-0 bottom-0 bg-black-alpha-20 z-1 text-center align-content-center">
      <i class="pi pi-lock" style="font-size: 3rem"></i>
    </div>
  }
</div>
